export const DEFAULT_EMAIL_PROVIDER = 'https://mail.google.com';

export const EMAIL_PROVIDER_CONFIG: Record<string, { webUrl: string; deepLink?: string }> = {
  // Gmail
  'gmail.com': { webUrl: DEFAULT_EMAIL_PROVIDER, deepLink: 'googlegmail://' },
  'googlemail.com': { webUrl: DEFAULT_EMAIL_PROVIDER, deepLink: 'googlegmail://' },

  // Yahoo Mail
  'yahoo.com': { webUrl: 'https://mail.yahoo.com', deepLink: 'ymail://' },
  'ymail.com': { webUrl: 'https://mail.yahoo.com', deepLink: 'ymail://' },

  // Outlook / Hotmail (Microsoft)
  'outlook.com': { webUrl: 'https://outlook.live.com/mail', deepLink: 'ms-outlook://' },
  'hotmail.com': { webUrl: 'https://outlook.live.com/mail', deepLink: 'ms-outlook://' },
  'live.com': { webUrl: 'https://outlook.live.com/mail', deepLink: 'ms-outlook://' },
  'msn.com': { webUrl: 'https://outlook.live.com/mail', deepLink: 'ms-outlook://' },

  // Apple Mail (iCloud)
  'icloud.com': { webUrl: 'https://www.icloud.com/mail', deepLink: 'message://' },
  'me.com': { webUrl: 'https://www.icloud.com/mail', deepLink: 'message://' },
  'mac.com': { webUrl: 'https://www.icloud.com/mail', deepLink: 'message://' },

  // AOL Mail
  'aol.com': { webUrl: 'https://mail.aol.com' },
};
